import React from "react";
import { Button as ChakraButton, ButtonProps } from "@chakra-ui/react";

export default function TransparentButton(props: ButtonProps) {
  return (
    <ChakraButton
      bg="transparent"
      _active={{ bg: "transparent" }}
      _hover={{ bg: "transparent" }}
      {...props}
      padding="0"
    >
      {props.children}
    </ChakraButton>
  );
}
